import { FC, useEffect, useState, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Grid, Paper, useMediaQuery, useTheme } from '@material-ui/core';
import LayersIcon from '@material-ui/icons/Layers';
import { useStyles } from './styles';
import { useStore } from '../../hooks/useRootStore';
import TableHeader from 'components/Headers/TableHeader';
import { useHistory } from 'react-router-dom';
import CommonTable from 'containers/CommonTable';
import { handleCompanyUrl } from 'utils/organizationUtils';

const Groups: FC = observer(() => {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const {
    ldapStore: {
      setGroupsKeywordFilter,
      clearClickedGroup,
      groupsView,
      getGroups,
      setClickedGroup,
      deleteGroup,
      // getSync,
      // syncs,
      getGroup,
      syncGroup,
    },
  } = useStore();

  const profile = JSON.parse(localStorage.getItem('Profile') as string);
  const userId = profile?.id;
  const getData =
    profile?.permission === 'EndUser'
      ? () => getGroup(userId)
      : profile?.permission === 'Manager' && !profile?.managed?.includes('groups')
      ? () => getGroup(userId)
      : profile?.permission === 'Manager'
      ? () => getGroups()
      : () => {}; // eslint-disable-line @typescript-eslint/no-empty-function
  const [loading, setLoading] = useState(false);
  const [groupsLoaded, setGroupsLoaded] = useState(false);
  const isFetching = useRef(false);

  useEffect(() => {
    const shouldLoadSpecificGroup = profile?.permission === 'Manager' && !profile?.managed?.includes('groups');
    const shouldLoadAllGroups = profile?.permission !== 'EndUser' && profile?.permission !== 'Manager';

    if (shouldLoadSpecificGroup && !groupsLoaded && !isFetching.current && userId) {
      setLoading(true);
      isFetching.current = true;
      getGroup(userId)
        .then((response) => {
          setGroupsLoaded(true);
        })
        .catch((error) => {
          console.error('getGroup error:', error);
          setGroupsLoaded(true);
        })
        .finally(() => {
          setLoading(false);
          isFetching.current = false;
        });
    } else if (
      Array.isArray(groupsView) &&
      groupsView.length === 0 &&
      shouldLoadAllGroups &&
      !groupsLoaded &&
      !isFetching.current
    ) {
      setLoading(true);
      isFetching.current = true;
      getGroups()
        .then((response) => {
          if (response?.data?.length > 0) {
            setGroupsLoaded(true);
          }
        })
        .catch(() => {
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
          isFetching.current = false;
        });
    }
  }, [groupsLoaded, groupsView.length, groupsView, profile?.permission, profile?.managed, getGroups, getGroup, userId]);

  useEffect(() => {
    if (history.action === 'POP') {
      localStorage.removeItem('CurrentGroup');
    }
    if (history.action === 'PUSH' && groupsLoaded) {
      setLoading(true);
      getGroups().finally(() => setLoading(false));
    }
    document.title = 'EasyIdentity: Groups';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid item xs={12}>
      <Container
        maxWidth={isMobile ? false : 'xl'}
        className={classes.container}
        style={isMobile ? { padding: '8px' } : {}}
      >
        <Grid className={classes.infoContainer} container alignItems='stretch' justify='flex-end'>
          <TableHeader
            headerLabel='Add New Group'
            headerAction={() => {
              localStorage.removeItem('CurrentGroup');
              history.push(handleCompanyUrl('/group/add'));
            }}
            headerChecked={true}
            headerIcon={<LayersIcon style={{ color: 'grey' }} />}
            searchAction={setGroupsKeywordFilter}
            hanleClicked={clearClickedGroup}
          />
        </Grid>
      </Container>
      <Container
        maxWidth={isMobile ? false : 'xl'}
        className={classes.tableBox}
        style={isMobile ? { padding: '4px' } : {}}
      >
        <Paper className={classes.paper}>
          <CommonTable
            getData={getData}
            deleteData={(status: any, appStatus: any) => deleteGroup(appStatus)}
            syncData={syncGroup}
            fieldtable='Group'
            dataHeadName='GROUP'
            dataLabel='List of Assigned Groups'
            dataName='cn'
            deleteLabel='Are you sure you want to delete?'
            view={groupsView}
            clickedData={setClickedGroup}
            tableIcon={<LayersIcon style={{ color: 'grey' }} />}
            viewTable={() => history.push(handleCompanyUrl('/group/users'))}
            editTable={() => history.push(handleCompanyUrl('/group/edit'))}
            dataValue={''}
            user={profile?.permission}
            loading={loading}
          />
        </Paper>
      </Container>
    </Grid>
  );
});

export default Groups;
